import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

import messages from 'messages';
import { useQueryClient } from 'react-query';

/* eslint no-restricted-globals:0 */

function Breadcrumb({ ...props }) {
    const history = useHistory();

    const queryClient = useQueryClient();
    const domain = queryClient.getQueryData('restaurant')?.domain || '';

    const [path, setPath] = useState(location.pathname);

    const { formatMessage } = props.intl;

    useEffect(() => {
        return history.listen((location) => {
            setPath(location.pathname);
        });
    }, [history]);

    const getTypeLink = () => {
        if (path.includes('experience')) {
            return (
                <Link
                    to={`/${domain}/experience`}
                    className={path.includes('experience') ? 'active' : ''}
                >
                    {formatMessage(messages.breadcrumbExperience)}
                </Link>
            );
        }

        if (path.includes('amount')) {
            return (
                <Link to={`/${domain}/amount`} className={path.includes('amount') ? 'active' : ''}>
                    {formatMessage(messages.breadcrumbAmount)}
                </Link>
            );
        }

        return <span>...</span>;
    };

    return (
        <div id="breadcrumb">
            <Breadcrumbs aria-label="breadcrumb">
                <Link to={`/${domain}/choose`} className={path.includes('choose') ? 'active' : ''}>
                    {formatMessage(messages.breadcrumbChoose)}
                </Link>

                {getTypeLink()}

                <Link to={`/${domain}/sender`} className={path.includes('sender') ? 'active' : ''}>
                    {formatMessage(messages.breadcrumbSender)}
                </Link>

                <Link to={`/${domain}/review`} className={path.includes('review') ? 'active' : ''}>
                    {formatMessage(messages.breadcrumbReview)}
                </Link>

                <Link
                    to={`/${domain}/payment`}
                    className={path.includes('payment') ? 'active' : ''}
                >
                    {formatMessage(messages.breadcrumbPayment)}
                </Link>
            </Breadcrumbs>
        </div>
    );
}

export default injectIntl(Breadcrumb);
